// Ikon marker bawaan Leaflet tidak ikut ter-bundle oleh webpack tanpa impor eksplisit.
// Modul ini dijalankan sekali (side effect) dan dipakai semua komponen peta.
import L from "leaflet";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";

L.Marker.prototype.options.icon = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
